"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
/**
 * Full Page spinner to indicate a loading screen
 *
 */
var ContainerDrawer = function (_a) {
    var open = _a.open, _b = _a.styles, styles = _b === void 0 ? {} : _b, _c = _a.size, size = _c === void 0 ? "250px" : _c, children = _a.children, className = _a.className, parentElement = _a.parentElement, _d = _a.showBackdrop, showBackdrop = _d === void 0 ? false : _d;
    var ref = react_1.useRef(null);
    var _e = react_1.useState({}), positionStyles = _e[0], setPositionStyles = _e[1];
    var baseStyle = {
        display: "flex",
        position: "absolute",
        zIndex: "9999",
        backgroundColor: "rgba(255, 255, 255, 0.8)"
    };
    react_1.useEffect(function () {
        if (ref.current && !parentElement) {
            setPositionStyles({
                top: ref.current.parentElement.offsetTop,
                left: ref.current.parentElement.offsetLeft,
                width: ref.current.parentElement.offsetWidth,
                height: ref.current.parentElement.offsetHeight
            });
        }
        if (parentElement) {
            setPositionStyles({
                top: parentElement.offsetTop,
                left: parentElement.offsetLeft,
                width: parentElement.offsetWidth,
                height: parentElement.offsetHeight
            });
        }
    }, [open, parentElement]);
    if (showBackdrop) {
        return (react_1.default.createElement("div", { ref: ref, className: "" + (className || ""), style: __assign(__assign(__assign(__assign({}, baseStyle), positionStyles), styles), { display: open ? "inherit" : "none", overflow: "hidden" }) },
            react_1.default.createElement("div", { style: __assign(__assign({}, positionStyles), { width: open ? size : "0px", backgroundColor: "rgba(255, 255, 255, 1)", overflow: "auto" }) }, children)));
    }
    return (react_1.default.createElement("div", { ref: ref, className: "" + (className || ""), style: __assign(__assign(__assign(__assign({}, baseStyle), positionStyles), styles), { width: open ? size : "0px", backgroundColor: "rgba(255, 255, 255, 1)", display: open ? "inherit" : "none", overflow: "auto" }) }, children));
};
ContainerDrawer.propTypes = {
    styles: prop_types_1.default.object,
    className: prop_types_1.default.string,
    parentElement: prop_types_1.default.node,
    children: prop_types_1.default.node,
    size: prop_types_1.default.string,
    open: prop_types_1.default.bool,
    showBackdrop: prop_types_1.default.bool
};
exports.default = ContainerDrawer;
